export default "__VITE_ASSET__XjBG5G3d__"